import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.scrollToBottom();

    // if a new message is added, scroll to the bottom
    let observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.type === "childList") {
          this.scrollToBottom();
        }
      }
    });

    observer.observe(this.element, { childList: true, subtree: true });
  }

  scrollToBottom() {
    let element = this.element;
    element.scrollTop = element.scrollHeight;
  }
}
